import { Check } from "lucide-react";

export const MONTHLY_TIERS = [
  { amount: 100, label: "A warm meal for 4 rescued dogs, every month" },
  { amount: 500, label: "A warm meal for 20 rescued dogs, every month" },
  { amount: 1000, label: "Become a Guardian — a warm meal for 40 rescued dogs, every month", recommended: true },
  { amount: 3000, label: "A warm meal for 120 rescued dogs, every month" },
  { amount: 5000, label: "A warm meal for 200 rescued dogs, every month" },
];

export function MonthlyTierPicker({ selectedAmount, hasCustomAmount, onSelect, testIdPrefix = "guardian" }) {
  return (
    <div className="space-y-2.5" data-testid={`${testIdPrefix}-monthly-tier-picker`}>
      {MONTHLY_TIERS.map((tier) => {
        const active = !hasCustomAmount && selectedAmount === tier.amount;
        return (
          <button
            key={tier.amount}
            type="button"
            onClick={() => onSelect(tier.amount)}
            data-testid={`${testIdPrefix}-tier-${tier.amount}`}
            className={`w-full flex items-center gap-3 rounded-2xl border px-4 py-3.5 text-left transition-all ${
              active
                ? "border-amtm-teal bg-amtm-teal/[0.06] ring-1 ring-amtm-teal"
                : "border-amtm-border hover:border-amtm-teal/50"
            }`}
          >
            <span
              className={`shrink-0 h-5 w-5 rounded-full border-2 flex items-center justify-center transition-colors ${
                active ? "border-amtm-teal bg-amtm-teal" : "border-amtm-border"
              }`}
            >
              {active && <Check className="h-3 w-3 text-white" strokeWidth={3} />}
            </span>
            <span className="flex-1">
              <span className="flex items-center gap-2">
                <span className="font-display text-lg text-amtm-text">₹{tier.amount.toLocaleString("en-IN")}/mo</span>
                {tier.recommended && (
                  <span className="text-[10px] font-bold uppercase tracking-wide bg-amtm-give text-amtm-giveText px-2 py-0.5 rounded-full">
                    Recommended
                  </span>
                )}
              </span>
              <span className="block text-xs text-amtm-textMuted mt-0.5">{tier.label}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
